import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  class: "w-full flex flex-col absolute top-0 left-0 right-0 bottom-0"
};
const _hoisted_2 = {
  class: "grow w-full px-2 overflow-y-scroll"
};
const _hoisted_3 = {
  key: 1
};
import Pagination from "@/modules/vue/components/Pagination.vue";
import { app } from "@/di";
import QueryOrder from "@/modules/vue/components/QueryOrder.vue";
import Icon from "@/modules/vue/components/Icon.vue";
import QueryFilterForm from "@/modules/vue/components/QueryFilterForm.vue";
import BadgeDot from "@/modules/vue/components/BadgeDot.vue";
import { isEqual } from "lodash";
import { TransitionFade } from "@morev/vue-transitions";
export default /*#__PURE__*/_defineComponent({
  __name: 'QueryPaginator',
  props: {
    query: null,
    perPage: {
      default: 10
    },
    startPage: {
      default: 1
    },
    order: null,
    filter: null,
    pageHandler: null
  },
  emits: ['update'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const items = ref([]);
    const orderField = ref(null);
    const orderOrder = ref(null);
    const orderFields = ref(props.order ? app.get(props.order).getFields() : null);
    const orderOnlySingleOrder = ref(props.order ? app.get(props.order).getOnlySingleOrder() : null);
    const isStandardOrder = computed(() => orderField.value === null && orderOrder.value === null);
    const filterDefaultForm = ref(props.filter ? app.get(props.filter).getForm().getDefaultForm() : null);
    const filterForm = ref(filterDefaultForm.value);
    const isStandardFilter = computed(() => {
      if (!props.filter) {
        return true;
      }
      return isEqual(app.get(props.filter).getForm().getDefaultForm(), filterForm.value);
    });
    const {
      perPage,
      currentPage,
      pageCount,
      showPrevPage,
      showNextPage
    } = usePagination(props.perPage, props.startPage);
    const {
      refresh,
      refreshing
    } = useAsyncInitial(async () => {
      let query = props.query.clone();
      if (props.filter) {
        query = app.get(props.filter).apply(query, filterForm.value);
      }
      if (props.order) {
        query = app.get(props.order).apply(query, orderField.value, orderOrder.value);
      }
      if (props.pageHandler) {
        query = props.pageHandler(query);
      } else {
        query = query.take(perPage.value).skip((currentPage.value - 1) * perPage.value);
      }
      const [allItems, count] = await query.getManyAndCount();
      items.value = allItems;
      pageCount.value = Math.ceil(count / perPage.value);
      emit('update', {
        items,
        currentPage,
        pageCount,
        perPage
      });
      nextTick(() => void 0);
    });
    watch(() => props.query, () => refresh());
    watch(() => currentPage.value, () => refresh());
    const onFilterUpdate = form => {
      filterForm.value = form;
      currentPage.value = 1;
    };
    expose({
      refresh
    });
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      const _component_NButton = _resolveComponent("NButton");
      const _directive_swipe_right = _resolveDirective("swipe-right");
      const _directive_swipe_left = _resolveDirective("swipe-left");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(TransitionFade), {
        mode: "out-in",
        duration: 500
      }, {
        default: _withCtx(() => [!_unref(refreshing) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [items.value.length === 0 ? _renderSlot(_ctx.$slots, "empty", {
          key: 0
        }, () => [_createVNode(_component_NEmpty, {
          description: _ctx.$t('no_entries')
        }, null, 8, ["description"])]) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
          items: items.value,
          currentPage: _unref(currentPage),
          pageCount: _unref(pageCount),
          perPage: _unref(perPage),
          refresh: _unref(refresh)
        })))]))], 64)) : _createCommentVNode("", true)]),
        _: 3
      })])), [[_directive_swipe_right, _unref(showPrevPage)], [_directive_swipe_left, _unref(showNextPage)]]), _renderSlot(_ctx.$slots, "pagination", _normalizeProps(_guardReactiveProps({
        items: items.value,
        currentPage: _unref(currentPage),
        pageCount: _unref(pageCount),
        perPage: _unref(perPage),
        refresh: _unref(refresh)
      })), () => [_createVNode(Pagination, {
        modelValue: _unref(currentPage),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(currentPage) ? currentPage.value = $event : null),
        "page-count": _unref(pageCount),
        onChange: _unref(refresh)
      }, _createSlots({
        controls: _withCtx(() => [__props.order ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(BadgeDot, {
          disabled: _unref(isStandardOrder)
        }, {
          default: _withCtx(() => [_createVNode(_component_NButton, {
            secondary: "",
            onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.queryOrder.show())
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: _ctx.IconEnum.SortOutlined
            }, null, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]), _createVNode(QueryOrder, {
          ref: "queryOrder",
          field: orderField.value,
          "onUpdate:field": _cache[1] || (_cache[1] = $event => orderField.value = $event),
          order: orderOrder.value,
          "onUpdate:order": _cache[2] || (_cache[2] = $event => orderOrder.value = $event),
          fields: orderFields.value,
          "only-single-order-mapping": orderOnlySingleOrder.value,
          onChanged: _unref(refresh)
        }, null, 8, ["field", "order", "fields", "only-single-order-mapping", "onChanged"])], 64)) : _createCommentVNode("", true), __props.filter ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(BadgeDot, {
          disabled: _unref(isStandardFilter)
        }, {
          default: _withCtx(() => [_createVNode(_component_NButton, {
            secondary: "",
            onClick: _cache[3] || (_cache[3] = () => _ctx.$refs.queryFilter.show())
          }, {
            default: _withCtx(() => [_createVNode(Icon, {
              icon: _ctx.IconEnum.FilterAltOutlined
            }, null, 8, ["icon"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]), _createVNode(QueryFilterForm, {
          ref: "queryFilter",
          "default-form": filterDefaultForm.value,
          "onUpdate:form": onFilterUpdate,
          onChanged: _unref(refresh)
        }, {
          default: _withCtx(args => [_renderSlot(_ctx.$slots, "form", _normalizeProps(_guardReactiveProps(args)))]),
          _: 3
        }, 8, ["default-form", "onChanged"])], 64)) : _createCommentVNode("", true)]),
        _: 2
      }, [_ctx.$slots.display ? {
        name: "display",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "display", _normalizeProps(_guardReactiveProps({
          items: items.value,
          currentPage: _unref(currentPage),
          pageCount: _unref(pageCount),
          perPage: _unref(perPage),
          refresh: _unref(refresh)
        })))])
      } : undefined]), 1032, ["modelValue", "page-count", "onChange"])])]);
    };
  }
});